// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3_GL1","secondary":"button_secondary__3v91q","tertiary":"button_tertiary__3VR_-"};